import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import '../NewConsentModal.css';
export default function HUTab({ setIdentifierToConsent, setNameToConsent, setVigency }) {

  const [consentExpiration, setConsentExpiration] = useState('1 mês');
  const consentExpirationOptions = [
    { display: '1 dia', value: 1 },
    { display: '1 semana', value: 7 },
    { display: '1 mês', value: 30 },
    { display: ' 1 ano', value: 365 },
    { display: 'Até revogação manual', value: null }];
  const { organizationList } = useNewConsentModalContext();
  const [orgSelected, setOrgSelected] = useState('');
  const [isOrgListOpen, setIsOrgListOpen] = useState(false);
  const [isExpirationListOpen, setIsExpirationListOpen] = useState(false);
  return (
    <>
      <div className="newConsentModal-selectInstituition">
        <div className="br-select">
          <div className="br-input">
            <label htmlFor="select-simple">Selecione a unidade de saúde com quem você deseja compartilhar suas informações de saúde:</label>
            <input
              id="select-simple"
              type="text"
              value={orgSelected}
              placeholder="Selecione o item"
              onClick={() => { setIsOrgListOpen(!isOrgListOpen); setIsExpirationListOpen(false); }} />
            <button onClick={() => setIsOrgListOpen(!isOrgListOpen)} className="br-button" type="button" aria-label="Exibir lista">
              {!isOrgListOpen
                ? <FaCaretDown />
                : <FaCaretUp />}
            </button>
          </div>
          {isOrgListOpen
            ? (
              <div className="newConsentModal br-list" style={{ display: 'block' }}>
                {
                  organizationList
                  && (
                    <>
                      {organizationList?.reverse().map((option, index) => (
                        <div className="br-item" key={index}>
                          <div className="br-radio">
                            <input
                              onClick={(e) => {
                                setIsOrgListOpen(!isOrgListOpen);
                                setOrgSelected(e.target.value);
                                setIdentifierToConsent(option.resource.identifier ? option.resource.identifier[0].value : 'Não Encontrado')
                                setNameToConsent(option.resource.alias[0]);
                              }}
                              id={`rb${index}`}
                              type="radio" name="organizationOptions"
                              value={option.resource.alias
                                ? option.resource.alias[0]
                                : 'Não Encontrado'}
                            />
                            <label htmlFor={`rb${index}`}>
                              {option.resource.alias
                                ? option.resource.alias[0]
                                : 'Não Encontrado'}
                            </label>
                          </div>
                        </div>

                      ))}
                    </>
                  )
                }
              </div>
            )
            : <></>}

        </div>
      </div>
      <div className='selectExpiration'>
        <div className="br-select">
          <div className="br-input">
            <p>Informe por quanto tempo você deseja compartilhar seu RES</p>
            <input
              id="select-expiration"
              type="text"
              value={consentExpiration}
              placeholder="Selecione o item"
              onClick={() => { setIsExpirationListOpen(!isExpirationListOpen); setIsOrgListOpen(false); }}
            />
            <button onClick={() => setIsExpirationListOpen(!isExpirationListOpen)} className="br-button" type="button" aria-label="Exibir lista">
              {!isExpirationListOpen
                ? <FaCaretDown />
                : <FaCaretUp />}
            </button>
          </div>
          {isExpirationListOpen
            ? (
              <div className="newConsentModal br-list" style={{ display: 'block' }}>
                {
                  consentExpirationOptions
                  && (
                    <>
                      {consentExpirationOptions.map((option, index) => (
                        <div className="br-item" key={index}>
                          <div className="br-radio">
                            <input
                              onClick={() => {
                                setIsExpirationListOpen(!isExpirationListOpen);
                                setConsentExpiration(option.display);
                                setVigency(option.value);
                              }}
                              id={`rb${index}`}
                              type="radio" name="consentExpirationOptions"
                              value={option}
                            />
                            <label htmlFor={`rb${index}`}>
                              {option.display}
                            </label>
                          </div>
                        </div>

                      ))}
                    </>
                  )
                }
              </div>
            )
            : <></>}

        </div>
      </div>
    </>

  );
}

HUTab.propTypes = {
  setIdentifierToConsent: PropTypes.element.isRequired,
  setVigency: PropTypes.element.isRequired,
  setNameToConsent:PropTypes.element.isRequired,
};
